import { Message } from 'element-ui'

export default {
  // 显示错误信息
  showErrorMsg(msg){
    this.showMsgDefaultDuration("error",msg);
  },

  // 显示警告信息
  showWarningMsg(msg){
    this.showMsgDefaultDuration("warning",msg);
  },

  //显示成功信息
  showSuccessMsg(msg){
    this.showMsgDefaultDuration("success",msg);
  },

  // 显示提示信息
  // 参数: 类型 内容
  showMsgDefaultDuration(type,msg){
    this.showMsg(type, msg, '3000');
  },

  // 显示提示信息
  // 参数:类型 内容 持续时间
  showMsg(type, msg, duration){
    Message({
      message: msg,
      type: type,
      duration: duration,
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/yjMessage.js